import './styles.scss';

/**
 * MainButton component renders a customizable button with support
 * for disabled state, custom styles, and click handling.
 *
 * @param {import("react").ReactNode} children — Content to be displayed inside the button.
 * @param {boolean} [disabled=false] — Disables the button when true.
 * @param {string} [className=''] — Additional CSS class for styling the button.
 * @param {Function} onClick — Callback function executed on button click.
 */

export default function MainButton({
    children,
    disabled = false,
    className = '',
    onClick,
}) {
    return (
        <button
            disabled={disabled}
            className={`main-btn ${className}`}
            onClick={onClick}>
            {children}
        </button>
    );
}
